import fetchData from "../../utils/fetchData";

export function getDashboard() {
  return fetchData({
    url: "/generals/dashboard",
    method: "GET"
  });
}
